import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const linkAllVariantsReducer = (state: VariantsState, action: PayloadAction<string[] | undefined>) => {
  const groupKeys = action.payload;
  state.variationGroups.forEach((group) => {
    if (groupKeys && !groupKeys.includes(group.key)) return;
    if (!group.linked) {
      group.linked = true;
    }
  });
};

export default linkAllVariantsReducer;
